"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("@mui/material/Button");
const ButtonOverrides = {
    MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
            root: {
                borderRadius: '4px',
                [`&.${Button_1.buttonClasses.sizeSmall}`]: {
                    fontSize: '0.875rem',
                    height: '30px',
                    paddingLeft: '10px',
                    paddingRight: '10px',
                },
                [`&.${Button_1.buttonClasses.sizeMedium}`]: {
                    fontSize: '0.875rem',
                    height: '36px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                },
                [`&.${Button_1.buttonClasses.sizeLarge}`]: {
                    fontSize: '0.875rem',
                    height: '42px',
                    paddingLeft: '20px',
                    paddingRight: '20px',
                },
                [`&.${Button_1.buttonClasses.loading}`]: { fontSize: '0' },
            },
            contained: ({ ownerState, theme }) => ({
                padding: '11px 16px',
                [`&.${Button_1.buttonClasses.disabled}`]: { color: 'white', backgroundColor: theme.palette.gray[300] },
                [`&.${Button_1.buttonClasses.loading}`]: Object.assign(Object.assign(Object.assign({ color: 'white' }, (ownerState.color === 'primary' && { backgroundColor: theme.palette.primary.main })), (ownerState.color === 'error' && { backgroundColor: theme.palette.error.main })), (ownerState.color === 'success' && { backgroundColor: theme.palette.success.main })),
                [`.${Button_1.buttonClasses.loadingIndicator}`]: { color: 'white' },
            }),
            outlined: ({ ownerState, theme }) => (Object.assign(Object.assign(Object.assign(Object.assign({ padding: '10px 16px' }, (ownerState.color === 'primary' && {
                borderColor: theme.palette.primary.main,
                ':hover': { backgroundColor: theme.palette.blue[100] },
            })), (ownerState.color === 'error' && {
                borderColor: theme.palette.error.main,
                ':hover': { backgroundColor: theme.palette.red[100] },
            })), (ownerState.color === 'success' && {
                borderColor: theme.palette.success.main,
                ':hover': { backgroundColor: theme.palette.green[100] },
            })), { [`&.${Button_1.buttonClasses.disabled}`]: { color: theme.palette.gray[500], borderColor: theme.palette.gray[300] }, [`&.${Button_1.buttonClasses.loading}`]: Object.assign(Object.assign(Object.assign({}, (ownerState.color === 'primary' && { borderColor: theme.palette.primary.main })), (ownerState.color === 'error' && { borderColor: theme.palette.error.main })), (ownerState.color === 'success' && { borderColor: theme.palette.success.main })), [`.${Button_1.buttonClasses.loadingIndicator}`]: Object.assign(Object.assign(Object.assign({}, (ownerState.color === 'primary' && { color: theme.palette.primary.main })), (ownerState.color === 'error' && { color: theme.palette.error.main })), (ownerState.color === 'success' && { color: theme.palette.success.main })) })),
            text: ({ ownerState, theme }) => (Object.assign(Object.assign(Object.assign(Object.assign({ padding: '8px 12px' }, (ownerState.color === 'primary' && { ':hover': { backgroundColor: theme.palette.blue[100] } })), (ownerState.color === 'error' && { ':hover': { backgroundColor: theme.palette.red[100] } })), (ownerState.color === 'success' && { ':hover': { backgroundColor: theme.palette.green[100] } })), { [`&.${Button_1.buttonClasses.disabled}`]: { color: theme.palette.gray[500] } })),
        },
    },
    MuiIconButton: {
        styleOverrides: {
            root: ({ theme }) => ({ padding: '4px', [`&.${Button_1.buttonClasses.disabled}`]: { color: theme.palette.gray[500] } }),
            sizeSmall: { fontSize: '8px' },
            sizeMedium: { fontSize: '16px' },
            sizeLarge: { fontSize: '24px' },
        },
    },
};
exports.default = ButtonOverrides;
//# sourceMappingURL=ButtonOverrides.js.map